import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Loader from '../../../components/common/Loader';
import { Card, CardHeader, CardBody } from 'reactstrap';
import Chart from "react-apexcharts";
import './Audience.css';

function RealLifeInterestsCard({ xx, width = "100%", interestRatios }) {
    const loading = useSelector(state => state.audienceInterests.loading);
    const [interestRatiosXX, setInterestRatiosXX] = useState({
        colors: ["#f50100", "#ff481e", "#ffb400", "#fff700", "#1ac0c6"],
        chart: {
            type: "bar",
        },
        plotOptions: {
            bar: {
                horizontal: true,
                distributed: true,
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return `${val.toFixed(1)}%`;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        series: [
            {
                name: "Ratio",
                data: [],
            },
        ],
        yaxis: {
            labels: {
                formatter: function (value) {
                    return value;
                },
            },
        },
        legend: {
            show: false,
        },
    });

    useEffect(() => {
        if (!Array.isArray(interestRatios)) {
            return;
        }

        const topInterestRatios = interestRatios
            .slice()
            .sort((a, b) => b.ratio - a.ratio)
            .slice(0, 5);

        const data = topInterestRatios.map(item => ({
            x: item.profileName,
            y: item.ratio,
        }));

        setInterestRatiosXX(prevOptions => ({
            ...prevOptions,
            series: [{ data }],
        }));
    }, [interestRatios, xx]);


    return (
        <Card className="real-life-interests-card">
            <CardHeader className="d-flex">
                <h4 className="card-title mb-0 flex-grow-1">
                    <b>Real Life Interests</b>
                </h4>
            </CardHeader>
            {loading ? (
                <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
                    <Loader />
                </CardBody>
            ) : (
                <CardBody className="real-life-interests-card-body">
                    <div id="realLifeInterests" className="real-life-interests-chart-container">
                        <Chart
                            type="bar"
                            options={interestRatiosXX}
                            series={xx === true ? interestRatiosXX.series : []}
                            width={"100%"}
                            height={340}
                        />
                    </div>
                </CardBody>
            )
            }
        </Card>
    );
}

export default RealLifeInterestsCard;
